import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';

const WidgetTag: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        style={customStyle}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M3 5v6.6a1 1 0 00.3.7l8.4 8.4a1 1 0 001.4 0l6.6-6.6a1 1 0 000-1.4L11.3 4.3a1 1 0 00-.7-.3H4a1 1 0 00-1 1zm4 3a1 1 0 100-2 1 1 0 000 2z" />
      </svg>
    </div>
  );
};

export default WidgetTag;
